import { render, staticRenderFns } from "./BillsTable.vue?vue&type=template&id=88054d1a&scoped=true&lang=html&"
import script from "./BillsTable.vue?vue&type=script&lang=js&"
export * from "./BillsTable.vue?vue&type=script&lang=js&"
import style0 from "./BillsTable.vue?vue&type=style&index=0&id=88054d1a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88054d1a",
  null
  
)

export default component.exports